import { UIKitLinkButton } from './UIKitLinkButton';
import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';
import { COMMON_COMPONENT_PROPS } from '../../../grapesJs/reactComponentsRegistry/const';

export const uiKitLinkButtonComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'uiKitLinkButton',
  component: UIKitLinkButton,
  tagName: 'uikitlinkbutton',
  stylable: true,
  droppable: false,
  defaultAttributes: {
    action: '',
    category: '',
    label: '',
    href: '#',
    theme: 'fill_primary',
    size: 'M',
    fullWidth: false,
  },
  traits: [
    {
      type: 'text',
      label: 'CA action',
      name: 'action',
    },
    {
      type: 'text',
      label: 'CA category',
      name: 'category',
    },
    {
      type: 'text',
      label: 'CA label',
      name: 'label',
    },
    {
      type: 'text',
      label: 'Link',
      name: 'href',
    },
    {
      type: 'select',
      label: 'Button size',
      name: 'size',
      default: 'M',
      options: [
        { id: 'L', value: 'L', name: 'L' },
        { id: 'M', value: 'M', name: 'M' },
        { id: 'XS', value: 'XS', name: 'XS' },
      ],
    },
    {
      type: 'text',
      label: 'Theme',
      name: 'theme',
    },
    {
      type: 'checkbox',
      label: 'Full width',
      name: 'fullWidth',
    },
    {
      type: 'checkbox',
      label: 'hasDeeplink (нужна поддержка нового webview на стороне апок',
      name: 'hasDeeplink',
    },
  ],
  block: {
    label: 'Link Button',
    category: 'UI Components',
    content: `
        <UIKitLinkButton href="#">Нажми меня</UIKitLinkButton>
      `,
  },
};
